// extracted by mini-css-extract-plugin
export default {"fullWidth":"ir-z","image":"jr-z","lazyLoadPicture":"kr-z","lazyLoadSpinner":"lr-z","lazyLoadSpin":"mr-z","lazyLoadImage":"nr-z","hasStyledAspectRatio":"or-z"};